<template>
  <div class="home"
       v-loading="loading">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="box">
      <div class="currency_box">
        <div class="kc_list font24"
             @click="toCourseList">案例列表</div>
        <div class="top_nav_list">
          <div class="top_nav_item"
               v-for="(item,index) in breadcrumbList"
               :key="index">{{item.name}}</div>
        </div>
      </div>
    </div>
    <!-- <el-image style="width:100%"
                :src="url"></el-image> -->
    <div class="currency_boxs">
      <div class="t font24">{{articleData.titleName}}</div>
      <!-- <div class="font24">{{articleData.titleTwoName}}</div> -->
      <div class="b">
        <span class="font14"> <i class="el-icon-time"></i> {{articleData.createTime}}</span>
        <span class="font14"> <i class="el-icon-thumb"></i> {{articleData.browseNum}}</span>
      </div>

      <div class="content"
           v-html="articleData.contentText"></div>
    </div>
  </div>
</template>

<script>
import { articleInfo } from '@/api/api.js'
export default {
  components: {},
  data () {
    return {
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      breadcrumbList: [
        { name: '内容详情' }
      ],
      articleData: {},

    }
  },
  created () {
    this.init()
  },
  filters: {

  },
  methods: {
    init () {
      if (this.$route.query.articleId) {
        this.data = {
          articleId: this.$route.query.articleId,
          articleClassify: this.$route.query.articleClassify
        }
        this.getarticleInfo()
      }
    },
    async getarticleInfo () {
      const res = await articleInfo(this.data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      this.articleData = res.data;
    },
    toCourseList () {
      this.$router.push('/Screen?type=article')
    },
    tabItem (index) {
      console.log(index)
      this.activeIndex = index;
      console.log(this.activeIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  background-color: #f5f5f5;
  min-height: 100vh;
  .menu_box {
    background-color: #f2eee8;
    width: 100%;
    height: 60px;
    margin-top: 50px;
  }
  // padding-top: 30px;
  .box {
    padding: 20px 0;
    box-sizing: border-box;
    background-color: #de1f26;
    color: #fff;
    .kc_list {
      font-weight: bold;
      padding-right: 18px;
      border-right: 1px solid #fff;
      cursor: pointer;
    }
    .top_nav_list {
      flex: 1;
      display: flex;
      padding-left: 30px;
      justify-content: flex-start;
      .top_nav_item {
        margin-right: 15px;
      }
    }
  }
  .t {
    color: #333;
    font-weight: bold;
    margin-top: 50px;
  }
  .b {
    color: #999;
    margin: 28px 0 30px 0;
    span {
      margin-right: 20px;
    }
  }
  .content {
    padding: 30px 0;
    box-sizing: border-box;
    border-top: 1px solid #e5e5e5;
  }
}
</style>
